export default __webpack_public_path__ + "static/media/media-flyer-4.642ecfab.jpg";